/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

export const AdultSwimLogo = new URL('../ts/multi-brand/adult-swim-logo.png', import.meta.url).href;
export const CartoonNetworkLogo = new URL('../ts/multi-brand/cartoon-network-logo.svg', import.meta.url).href;
export const CartoonitoLogo = new URL('../ts/multi-brand/cartoonito-logo.png', import.meta.url).href;
export const FormatsPortalLogo = new URL('../ts/multi-brand/formats-logo.svg', import.meta.url).href;
export const HBOLogo = new URL('../ts/multi-brand/hbo-logo.svg', import.meta.url).href;
export const HBOMaxLogo = new URL('../ts/multi-brand/hbo-max-logo.svg', import.meta.url).href;
export const WBTVDPressLogo = new URL('../ts/multi-brand/wb-press-logo.png', import.meta.url).href;
export const WBTVDLogo = new URL('../ts/multi-brand/wbtvd-logo.png', import.meta.url).href;
